module.exports = __webpack_public_path__ + "assets/forgot-password-v2-dark.1ef808f2.svg";